// extracted by mini-css-extract-plugin
export default {"addressField":"AddressField_addressField__gnSC4","label":"AddressField_label__9cKI5","input":"AddressField_input__py-Kt"};